import { Download } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export const ExportBar = ({ onNotebook, onCsv, prefix }) => {
  const run = (fn, label) => { try { fn(); toast.success(`${label} downloaded`); } catch (e) { toast.error(e.message); } };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${prefix}-export-bar`}>
      <span className="text-xs font-mono text-muted-foreground"># export:</span>
      <Button data-testid={`${prefix}-export-ipynb`} size="sm" variant="outline" className="h-7 text-xs" onClick={() => run(onNotebook, "Notebook")}><Download className="h-3.5 w-3.5 mr-1" />.ipynb</Button>
      <Button data-testid={`${prefix}-export-csv`} size="sm" variant="outline" className="h-7 text-xs" onClick={() => run(onCsv, "CSV")}><Download className="h-3.5 w-3.5 mr-1" />.csv</Button>
    </div>
  );
};
